import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

axios.defaults.timeout = 30000
const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/admin`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const botProfileApi = {
  getBotProfile: (request) => {
    // page_id:247498961787606
    // id:1
    // name:test
    // is_active:true
    // datefrom:2024-04-28
    // dateto:2024-04-29
    // limit:10
    // offset:0
    const { params } = request
    const url = `/bot-profile`
    return instance().get(url, { params })
  },
  postBotProfile: (request) => {
    const url = `/bot-profile`
    const { data } = request
    return instance().post(url, data)
  },
  putBotProfile: (request) => {
    // "id": "1",
    // "page_id": "247498961787606",
    // "name": "Test Tigerpoly",
    // "profile_pic": "https://zwizai.s3.amazonaws.com/ecommerce/1714380185249_test.png",
    // "is_active": true
    const url = `/bot-profile`
    const { data } = request
    return instance().put(url, data)
  },
  deleteBotProfile: (request) => {
    // "id": "4",
    // "page_id": "247498961787606"
    const url = `/bot-profile`
    const { data } = request
    return instance().delete(url, { data })
  }
}
export default botProfileApi



// WEBPACK FOOTER //
// ./src/api/bot-profile/bot-profile.js